<!--
 * @Description: 
 * @Author: xiaoq
 * @Date: 2024-06-13 16:04:03
 * @LastEditTime: 2024-09-14 11:22:36
 * @LastEditors: xiaoq
-->
<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem1" />
        <router-link to="/" class="nav-link1"> </router-link>
        <router-link to="/service" class="nav-link2"> </router-link>
        <router-link to="/about" class="nav-link3"> </router-link>
        <router-link to="/question" class="nav-link4"> </router-link>
        <router-link to="/new" class="nav-link5"> </router-link>
        <router-link to="/contact" class="nav-link6"> </router-link>
        <a
          href="https://quick.mackale.com/privacy_policy"
          class="nav-link7"
        ></a>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/quick.mackale/components/img/footer.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      altText: "图片",
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box {
  width: 100%;
  overflow: hidden;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6 {
  width: 100%;
  margin: auto;
}

.img1Box {
  margin-top: -2px;
  position: relative;
}

.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5,
.nav-link6,
.nav-link7 {
  /* border: 1px solid red; */
  position: absolute;
  left: 0;
  top: 0;
  width: 200px;
  height: 40px;
  height: 9%;
}
.nav-link1 {
  left: 53%;
  top: 13%;
  width: 7.5%;
}
.nav-link2 {
  left: 53%;
  top: 25%;
  width: 10%;
}
.nav-link3{
  left: 53%;
  top: 38%;
  width: 9%;
}
.nav-link4{
  left: 53%;
  top: 50.5%;
  width: 11.5%;
}
.nav-link5{
  left: 53%;
  top: 63%;
  width: 5%;
}
.nav-link6 {
  left: 68%;
  top: 13%;
  width: 9.5%;
}

.nav-link7{
  left: 68%;
  top: 25%;
  width: 15.5%;
}
</style>
